import { createAction } from 'redux-act';

export const setUsersTabValue = createAction('Set Users tab value');

export const resetWidgetReducer = createAction('Reset widget reducer');
